import React from 'react';
import PropTypes from 'prop-types';
import DataVisualization from '../DataVisualization/DataVisualization';
import CryptoMarkets from '../CryptoMarkets/CryptoMarkets';
import ScatterPlot from '../ScatterPlot';
import './ChartContainer.css';

/**
 * ChartContainer component that renders different chart components based on configuration
 * 
 * @param {Object} props - Component props
 * @param {string} props.type - Type of chart to render (matches component name in config)
 * @param {Object} props.config - Configuration for the chart
 * @param {string} props.className - Additional CSS class
 * @returns {JSX.Element} - Rendered component
 */
const ChartContainer = ({ type, config, className = '' }) => {
  // If no config is provided or chart is not visible, don't render anything
  if (!config || config.visible === false) {
    return null;
  }

  // Render the appropriate chart component based on type
  const renderChart = () => {
    switch (type) {
      case 'CryptoMarkets':
        return (
          <CryptoMarkets 
            data={config.data} 
            options={config.options}
            className="chart-component"
          />
        );
      case 'DataVisualization':
        return <DataVisualization className="chart-component" />;
      case 'ScatterPlot':
        return <ScatterPlot className="chart-component" />;
      default:
        return (
          <div className="chart-placeholder">
            Chart type "{type}" not found
          </div>
        );
    }
  };

  return (
    <div className={`chart-container ${className}`}>
      {config.title && <h3 className="chart-title">{config.title}</h3>}
      {config.description && <p className="chart-description">{config.description}</p>}
      <div className="chart-content">
        {renderChart()}
      </div>
    </div>
  );
};

ChartContainer.propTypes = {
  type: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default ChartContainer;
